// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  favorId: __t.u64().primaryKey().name("favor_id"),
  versonaId: __t.u64().name("versona_id"),
  identity: __t.identity(),
  worldId: __t.u64().name("world_id"),
  kind: __t.string(),
  targetKey: __t.string().name("target_key"),
  qty: __t.u32(),
  detail: __t.string(),
  state: __t.string(),
  offeredAt: __t.timestamp().name("offered_at"),
  expiresAt: __t.timestamp().name("expires_at"),
  updatedAt: __t.timestamp().name("updated_at"),
});
